export const MAX_CONTACT_ENTRIES = 5;

export const CONTACT_ENTRY_LABELS = {
  primary: 'Primarni',
  secondary: 'Sekundarni',
  additional: 'Dodatni',
};

export function defaultContactEntryLabel(index) {
  if (index === 0) {
    return CONTACT_ENTRY_LABELS.primary;
  }
  if (index === 1) {
    return CONTACT_ENTRY_LABELS.secondary;
  }
  return `${CONTACT_ENTRY_LABELS.additional} ${index - 1}`;
}

export function createEmptyContactEntry(index = 0) {
  return {
    label: defaultContactEntryLabel(index),
    value: '',
  };
}

export function normalizeContactEntry(raw, index, dedupeKeyForValue) {
  if (typeof raw === 'string') {
    const value = raw.trim();
    if (!value) {
      return null;
    }
    return {
      label: defaultContactEntryLabel(index),
      value,
    };
  }

  if (!raw || typeof raw !== 'object') {
    return null;
  }

  const value = String(
    raw.value ?? raw.address ?? raw.number ?? raw.email ?? raw.phone ?? '',
  ).trim();
  if (!value) {
    return null;
  }

  const label = String(raw.label || '').trim() || defaultContactEntryLabel(index);
  return { label, value };
}

export function normalizeContactEntries(values, dedupeKeyForValue) {
  if (!Array.isArray(values)) {
    return [];
  }

  const seen = new Set();
  const result = [];

  values.forEach((raw, index) => {
    const entry = normalizeContactEntry(raw, index, dedupeKeyForValue);
    if (!entry) {
      return;
    }

    const key = dedupeKeyForValue(entry.value);
    if (seen.has(key)) {
      return;
    }

    seen.add(key);
    result.push(entry);
  });

  return result.slice(0, MAX_CONTACT_ENTRIES);
}

export function resolveContactEntriesFromData(data, {
  arrayField,
  legacyField,
  dedupeKeyForValue,
}) {
  const rawList = data[arrayField];
  if (Array.isArray(rawList) && rawList.length) {
    return normalizeContactEntries(rawList, dedupeKeyForValue);
  }

  const legacyValue = data[legacyField] && String(data[legacyField]).trim();
  if (legacyValue) {
    return normalizeContactEntries([legacyValue], dedupeKeyForValue);
  }

  return [];
}

export function primaryContactEntry(entries = []) {
  return entries[0] || null;
}

export function primaryContactEntryValue(entries = []) {
  return primaryContactEntry(entries)?.value || '';
}

export function formatContactEntrySummary(entries = []) {
  return primaryContactEntryValue(entries);
}

export function contactEntryKey(entry) {
  return `${entry?.label || ''}::${entry?.value || ''}`;
}
